import { httpsCallable } from "firebase/functions";
import { createResult, getFnResponseData } from "global/altFunctions/common";
import _ from 'lodash';
import { _showAppLogs } from "../LogContext";

const _showCallErrorLogs = false

export const fsCallAll = async (mainFunctions, genericType, callData, allFunctions, useProd) => {

  let ft;
  const _keys = Object.keys(callData)

  if (_keys) {
    _keys.forEach(key => {
      if (key.endsWith('FunctionType')) {
        ft = callData[key];
      }
    })
  }

  const _fns = mainFunctions //useProd && allFunctions['prodFunctions'] ? allFunctions['prodFunctions'] : mainFunctions

  try {
    const _rsp = (await httpsCallable(_fns, genericType)(callData))
    if (_showAppLogs.fsCalls) {
      console.group('callData')
      console.log('🌐➡️', callData)
      console.log('🌐✅', _rsp)
      console.groupEnd()
    }
    _showAppLogs.fsCalls && console.log(' < fsCall: response:', _rsp)
    return getFnResponseData(_rsp)
  } catch (error) {
    _showCallErrorLogs && console.log(' < fsCall: error:', error)
    // const _docRef = createRefPath(['_funtionsError', 'app', _settingsFs.collection, sk])
    // promises.push(database_fns.set_doc(_docRef, setting, true))
    return createResult(false, {}, error)
  }
}

export const fsCall_generic = async (functionsInstance, functionType, callData) => {
  try {
    _showAppLogs.fsCalls && console.log(' > fsCall_generic', functionType, callData)
    const _rsp = (await httpsCallable(functionsInstance, functionType)(callData))
    _showAppLogs.fsCalls && console.log(' < fsCall_generic', _rsp)
  } catch (error) {
    console.log('callFunction - error', error)
  }
}
